export class QuoteBasicInformation {
    formStatus = 'started';

    companyLegalName: string = '';
    dbaName: string = '';
    companyLegalEntity: Object = [
        {legalEntityId: "", legalEntityName: "", displayName: "Select...", isSelected: true},
        {legalEntityId: "LLC", legalEntityName: "Limited Liability Company", displayName: "Limited Liability Company", isSelected: false},
        {legalEntityId: "Corp", legalEntityName: "Corporation", displayName: "Corporation", isSelected: false},
        {legalEntityId: "Part", legalEntityName: "Partnership", displayName: "Partnership", isSelected: false},
        {legalEntityId: "Ind", legalEntityName: "Individual", displayName: "Individual", isSelected: false}
    ];
    feinNumber: number;
    website: string = '';

    usStates: Object = [];

    insuredCareof: string = '';
    insuredAddressLine1: string;
    insuredAddressLine2: string;
    insuredCity: string;
    insuredState: string;
    insuredZip: string;
    
    mailingCareof: string;
    mailingAddressLine1: string;
    mailingAddressLine2: string;
    mailingCity: string;
    mailingState: string;
    mailingZip: string;

    billingCareof: string;
    billingAddressLine1: string;
    billingAddressLine2: string;
    billingCity: string;
    billingState: string;
    billingZip: string;

    sameAsInsuredAddress: boolean = false;
    sameAsMailingAddress: boolean = false;

    insuredAddress: any;
    mailingAddress: any;
    billingAddress: any;

    addressVerified: string = "Verified";
    addressOverride: string = "Overridden";

    selectedInsuredAddress: any = { addressLine1: "", addressLine2: "", city: "", state: "", zip: "", county: "", country: "USA", isVerified: 'Verified' };
    selectedMailingAddress: any = { addressLine1: "", addressLine2: "", city: "", state: "", zip: "", county: "", country: "USA", isVerified: 'Verified' };
    
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    phone: number;
}